// History
export const SET_IMPORT_FILES_HISTORY = 'SET_IMPORT_FILES_HISTORY';
export const SET_IS_LOADING_GET_IMPORT_FILES_HISTORY = 'SET_IS_LOADING_GET_IMPORT_FILES_HISTORY';
export const SET_SELECTED_IMPORT_FILES_HISTORY = 'SET_SELECTED_IMPORT_FILES_HISTORY';
// Audiences
export const SET_AUDIENCES = 'SET_AUDIENCES';
export const SET_IS_LOADING_GET_AUDIENCES = 'SET_IS_LOADING_GET_AUDIENCES';
export const SET_AUDIENCE_SELECTED = 'SET_AUDIENCE_SELECTED';
export const CREATE_AUDIENCE = 'CREATE_AUDIENCE';
export const SET_IS_LOADING_CREATE_AUDIENCE = 'SET_IS_LOADING_CREATE_AUDIENCE';
export const UPDATE_AUDIENCE = 'UPDATE_AUDIENCE';
export const SET_IS_LOADING_UPDATE_AUDIENCE = 'SET_IS_LOADING_UPDATE_AUDIENCE';
// Mapping fields
export const SET_MAPPING_FIELDS = 'SET_MAPPING_FIELDS';
export const SET_IS_LOADING_GET_MAPPING_FIELDS = 'SET_IS_LOADING_GET_MAPPING_FIELDS';
export const SET_MAPPING_FIELDS_AUDIENCE_SELECTED = 'SET_MAPPING_FIELDS_AUDIENCE_SELECTED';
export const SET_MAPPING_FIELD_SELECTED = 'SET_MAPPING_FIELD_SELECTED';
export const CREATE_MAPPING_FIELD = 'CREATE_MAPPING_FIELD';
export const SET_IS_LOADING_CREATE_MAPPING_FIELD = 'SET_IS_LOADING_CREATE_MAPPING_FIELD';
export const UPDATE_MAPPING_FIELD = 'UPDATE_MAPPING_FIELD';
export const SET_IS_LOADING_UPDATE_MAPPING_FIELD = 'SET_IS_LOADING_UPDATE_MAPPING_FIELD';
export const DELETE_MAPPING_FIELD = 'DELETE_MAPPING_FIELD';
export const SET_IS_LOADING_DELETE_MAPPING_FIELD = 'SET_IS_LOADING_DELETE_MAPPING_FIELD';
// Mappings
export const SET_MAPPINGS = 'SET_MAPPINGS';
export const SET_IS_LOADING_GET_MAPPINGS = 'SET_IS_LOADING_GET_MAPPINGS';
export const CREATE_MAPPING = 'CREATE_MAPPING';
export const SET_IS_LOADING_CREATE_MAPPING = 'SET_IS_LOADING_CREATE_MAPPING';
export const SET_CREATE_MAPPING_SELECTED = 'SET_CREATE_MAPPING_SELECTED';
export const UPDATE_MAPPING = 'UPDATE_MAPPING';
export const SET_IS_LOADING_UPDATE_MAPPING = 'SET_IS_LOADING_UPDATE_MAPPING';
export const DELETE_MAP = 'DELETE_MAP';
export const SET_IS_LOADING_DELETE_MAP = 'SET_IS_LOADING_DELETE_MAP';
export const SET_MAPPING_SELECTED = 'SET_MAPPING_SELECTED';
export const SET_RECORD_TO_UPDATE = 'SET_RECORD_TO_UPDATE';
// CSV Selected
export const SET_CSV_SELECTED = 'SET_CSV_SELECTED';
export const SET_IS_LOADING_CSV_SELECTED = 'SET_IS_LOADING_CSV_SELECTED';
// Points of sale dictionaries
export const SET_POINTS_OF_SALE_DICTIONARY = 'SET_POINTS_OF_SALE_DICTIONARY';
export const SET_IS_LOADING_GET_POINTS_OF_SALE_DICTIONARY = 'SET_IS_LOADING_GET_POINTS_OF_SALE_DICTIONARY';
export const SET_POINT_OF_SALE_DICTIONARY_SELECTED = 'SET_POINT_OF_SALE_DICTIONARY_SELECTED';
export const CREATE_POINTS_OF_SALE_DICTIONARY = 'CREATE_POINTS_OF_SALE_DICTIONARY';
export const SET_IS_LOADING_CREATE_POINTS_OF_SALE_DICTIONARY = 'SET_IS_LOADING_CREATE_POINTS_OF_SALE_DICTIONARY';
export const UPDATE_POINTS_OF_SALE_DICTIONARY = 'UPDATE_POINTS_OF_SALE_DICTIONARY';
export const SET_IS_LOADING_UPDATE_POINTS_OF_SALE_DICTIONARY = 'SET_IS_LOADING_UPDATE_POINTS_OF_SALE_DICTIONARY';
export const DELETE_POINTS_OF_SALE_DICTIONARY = 'DELETE_POINTS_OF_SALE_DICTIONARY';
export const SET_IS_LOADING_DELETE_POINTS_OF_SALE_DICTIONARY = 'SET_IS_LOADING_DELETE_POINTS_OF_SALE_DICTIONARY';
// Files Patterns
export const SET_FILE_PATTERNS = 'SET_FILE_PATTERNS';
export const SET_IS_LOADING_GET_FILE_PATTERNS = 'SET_IS_LOADING_GET_FILE_PATTERNS';
export const CREATE_FILE_PATTERN = 'CREATE_FILE_PATTERN';
export const SET_IS_LOADING_CREATE_FILE_PATTERN = 'SET_IS_LOADING_CREATE_FILE_PATTERN';
// Upload files
export const SET_IS_LOADING_UPLOAD_FILES = 'SET_IS_LOADING_UPLOAD_FILES';
// Reprocess imports
export const SET_IS_LOADING_REPROCESS_IMPORT = 'SET_IS_LOADING_REPROCESS_IMPORT';
export const SET_IS_LOADING_ARCHIVE_FILE_HISTORY = 'SET_IS_LOADING_ARCHIVE_FILE_HISTORY';